import { makeAutoObservable } from "mobx";
import { createMutations } from "./mutations";
import { initialState } from "./state";

const profilesAddonStore = () => {
  const store = { ...initialState };
  makeAutoObservable(store);
  Object.assign(store, createMutations(store));
  return store;
};

export default profilesAddonStore();
